<template lang="pug">
.missions-list
  h3 {{ $t(title) }}

  ProfileTabs(v-if="!isOfferWall" :items="tabs" :active-tab-index="currentTabIndex" @change="onTabChange").missions-list__tabs

  // iframe(v-if="desktopWall" :src="desktopWall" @click="onClickIframe" frameborder="0" width="100%" height="1000")
  .missions-list__section(v-if="!isOfferWall && quests")
    .missions-list__section-header
      .missions-list__section-title {{ $t('questsCompleted') }}
      .missions-list__section-counter {{ completedQuests.length }} / {{ allQuests.length }}

    .missions-list__section-body
      transition-group(name="flip-list" tag="div")
        .missions-list__quest(
          v-for="(quest, index) in allQuests"
          :key="quest.task.type + quest.task.prize_amount + index"
          :class="{ '--claimed': quest.is_done, '--completed': quest.is_eligible, '--partner': quest.task.type === 'partner', '--betfury': quest.task.type === 'betfury' }"
          @click="questClick(quest)"
        )
          .missions-list__quest-left
            img(:src="getQuestIcon(quest)" alt="icon").missions-list__quest-icon
            .missions-list__quest-title {{ quest.task.title }}

          .missions-list__quest-right
            Currency(:type="quest.task.prize_currency" is-reversed) {{ prizeAmount(quest) }}
            .missions-list__quest-claim(v-if="quest.is_eligible && !quest.is_done" @click="onClaimClick(quest)")
              | {{ $t('claimReward') }}

  iframe(v-else-if="mode === 'iframe'" :src="offerWallUrl" @click="onClickIframe" frameborder="0" width="100%" height="1000")
  iframe(v-else-if="mode === 'async-iframe' && offerWallUrlFromFunc" :src="offerWallUrlFromFunc" @click="onClickIframe" frameborder="0" width="100%" height="1000")
  MissionsFrame(v-else-if="mode === 'api'" :data="offerwallData")
  Button(v-else-if="showPollfishButton" is-primary @click="startPollfish") {{ $t("start") }}
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import MissionsFrame from './MissionsFrame'
import CopyInput from '~/components/CopyInput/CopyInput'
import ProfileTabs from '~/components/ProfileTabs/ProfileTabs'
import InfoMessage from '~/components/InfoMessage/InfoMessage'
import mockQuests from '~/data/mock/quests'

export default {
  name: 'MissionsList',

  components: {
    MissionsFrame,
    CopyInput,
    ProfileTabs,
    InfoMessage
  },

  props: {
    isOfferWall: {
      type: Boolean,
      default: false
    },

    offerWallUrl: {
      type: String,
      default: ''
    },

    desktopWall: {
      type: String,
      default: undefined
    },

    asyncOfferwallUrl: {
      type: Function,
      default: undefined
    },

    mode: {
      type: String,
      default: 'iframe'
    },

    offerwallData: {
      type: Object,
      default: undefined
    },

    title: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      showQuestList: true,

      showPollfishButton: false,

      tabs: [
        {
          title: this.$t('questsCommon'),
          id: 'forever'
        },
        {
          title: this.$t('questsDaily'),
          id: 'daily',
          isDisabled: false
        },
        {
          title: this.$t('questsWeekly'),
          id: 'weekly',
          isDisabled: false
        }
      ],

      currentTabIndex: 0,

      offerWallUrlFromFunc: undefined,

      quests: mockQuests // for funny loading effect
    }
  },

  computed: {
    ...mapState('user', ['user']),
    ...mapGetters('user', ['isAuthorized']),

    userId () {
      return this.user?.id
    },

    currentTab () {
      return this.tabs[this.currentTabIndex]
    },

    allQuests () {
      if (Array.isArray(this.quests)) {
        return this.quests
      }
      return []
    },

    completedQuests () {
      return this.allQuests.filter(q => q.is_done)
    }
  },

  async mounted () {
    this.updateQuests('forever')
    const self = this

    console.log('mode', this.mode)

    if (this.mode === 'async-iframe' && this.asyncOfferwallUrl) {
      this.offerWallUrlFromFunc = await this.asyncOfferwallUrl()
    }

    if (this.mode === 'sdk' && this.isAuthorized) {
      window.pollfishConfig = {
        api_key: '8eab41ca-ab76-4594-917b-e632ef90a386',
        debug: process.env.NODE_ENV === 'development',
        ready: () => {},
        userId: this.user?.id,
        clickId: this.user?.id,
        offerwall: true
      }
      const addScript = (url, onLoad) => {
        const scriptExists = document.querySelector(`script[src='${url}']`)

        if (!scriptExists) {
          const script = document.createElement('script')

          document.body.appendChild(script)

          script.onload = () => {
            onLoad && onLoad()
          }

          script.src = url
        }
      }

      addScript('https://ajax.googleapis.com/ajax/libs/jquery/1.11.2/jquery.min.js', () => {
        console.log('jquery ok')
        addScript('https://storage.googleapis.com/pollfish_production/sdk/webplugin/pollfish.min.js', () => {
          console.log('start pollfish', window.Pollfish, this)
        })
      })

      setTimeout(() => {
        self.showPollfishButton = true
      }, 5000)
    }
  },

  methods: {
    ...mapActions('modal', ['showModal']),

    async updateQuests (period) {
      try {
        const { data } = await this.$axios.get(`/tasks/task/${period}`)
        this.quests = data.data.map((quest) => {
          let locale = this.$i18n.locale
          if (!quest.task?.extra_data?.text?.[locale]) {
            locale = 'en'
          }

          quest.task.title = quest.task?.extra_data?.text?.[locale]?.title

          return quest
        })
        // this.quests.sort(this.sortQuestsFunc())
      } catch (e) {
        console.error(
          `${new Date().toUTCString()} :: quests update error ::`,
          e
        )
      }
    },

    onClickIframe () {
      // this.$gtag.event('click_missions_iframe', {})
    },

    async onTabChange ({ index, item }) {
      await this.updateQuests(item.id)
      this.currentTabIndex = index
    },

    startPollfish () {
      if (this.isAuthorized) {
        window.Pollfish.showFullSurvey()
      } else {
        this.showModal({
          component: 'Auth',
          data: {
            mode: 'register'
          }
        })
      }
    },

    sortQuestsFunc () {
      return (a, b) => {
        // Показываем самыми первыми задания, которые выполнены, но не собраны
        const firstCond =
          (b.is_eligible && !b.is_done) - (a.is_eligible && !a.is_done)

        // Показываем последними задания, которые выполнены и собраны
        const secondCond = a.is_eligible - b.is_done

        return firstCond || secondCond
      }
    },

    async onClaimClick (quest) {
      try {
        await this.$axios.post(`/tasks/${quest?.task.id}`)
        await this.updateQuests(this.currentTab.id)
      } catch (e) {
        console.error(
          `${new Date().toUTCString()} :: quests update error ::`,
          e
        )
      }
    },

    questClick (quest) {
      if (quest.is_eligible || quest.is_done) {
        return
      }
      if (quest.task.type === 'partner') {
        let locale = this.$i18n.locale?.split?.('-')[0] || 'en'
        if (locale !== 'ru') {
          locale = 'en'
        }
        console.log('quest', quest.task)
        this.showModal({
          component: 'ModalMission',
          data: {
            image: quest.task.extra_data.image_url || 'https://cdn.gaming-goods.com/images/modals/missionsJackPot-en.jpg',
            buttonLink: quest.task.extra_data.link.replace('{userId}', `${this.userId}`),
            body: quest.task.extra_data.text[locale].modalBody,
            title: quest.task.extra_data.text[locale].modalTitle,
            id: quest.task.id
          }
        })
      } else if (quest.task.extra_data.link) {
        if (quest.task.extra_data.link.indexOf('/') === 0) {
          this.$router.push(this.localeLocation(quest.task.extra_data.link))
        } else {
          location.href = quest.task.extra_data.link
        }
      }
    },

    getQuestIcon (quest) {
      let icon

      switch (quest.task.type) {
        case 'partner':
          icon = require('~/assets/img/quests/medal.svg')
          break
        default:
          icon = require(`~/assets/img/quests/${quest?.task?.extra_data?.image_url || 'medal'}.svg`)
      }

      if (quest.is_done) {
        icon = require('~/assets/img/quests/checkmark.svg')
      }

      if (!icon) {
        icon = require('~/assets/img/quests/medal.svg')
      }

      return icon
    },

    prizeAmount (quest) {
      return quest.task.prize_currency === 'money'
        ? quest.task.prize_amount / 100
        : quest.task.prize_amount
    }
  }
}
</script>

<style lang="scss">
.missions-list {
  h3 {
    font-style: normal;
    font-weight: 700;
    font-size: 28px;
    line-height: 36px;
    color: $white;
    margin-bottom: 16px;
  }

  &__tabs {
    margin-bottom: 40px;
  }

  &__info {
    margin-bottom: 12px;

    a {
      text-decoration: underline;
    }

    .button {
      display: block;
      margin-top: 16px;
    }
  }

  &__section {
    background-color: $blue-grey70;
    border-radius: 16px;
    color: $white;

    &-header {
      display: flex;
      padding: 24px;
      border-bottom: 1px solid $blue-grey40;
    }

    &-title {
      @include heading4;
    }

    &-counter {
      @include heading5;

      color: $blue-grey10;
      margin-left: 11px;
      position: relative;
      top: 4px;
    }

    &-body {
      padding: 24px;
    }
  }

  &__quest {
    display: flex;
    justify-content: space-between;
    background-color: $blue-grey60;
    min-height: 68px;
    padding: 0 24px;
    border-radius: 8px;
    cursor: pointer;

    &-left {
      display: flex;
      align-items: center;
      width: 100%;
    }

    &-right {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-end;
      width: 140px;
    }

    &-icon {
      width: 100%;
      height: 100%;
      max-width: 32px;
      max-height: 32px;
      margin-right: 20px;

      path {
        fill: #9bafca;
      }
    }

    &-title {
      @include hint;

      font-family: Roboto, sans-serif;
    }

    &-claim {
      @include button2;

      color: $primary60;
      cursor: pointer;
      min-width: 110px;
    }

    &.--claimed {
      .missions-list__quest-title {
        color: $green50;
      }

      .missions-list__quest-icon path {
        fill: $green50;
      }
    }

    &.--partner {
      background-color: rgba(255, 193, 7, 0.1);
      position: relative;
      cursor: pointer;

      &::before {
        position: absolute;
        content: "";
        width: 33px;
        height: 20px;
        left: 0;
        top: 0;
        border-left: 3px solid #ffec5d;
        border-top: 3px solid #ffec5d;
      }

      &::after {
        position: absolute;
        content: "";
        width: 33px;
        height: 20px;
        right: 0;
        bottom: 0;
        border-right: 3px solid #ffec5d;
        border-bottom: 3px solid #ffec5d;
      }

      .missions-list__quest-title {
        color: $white;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;
      }

      .missions-list__quest-left {
        img {
          path {
            fill: #ffcc32;
          }
        }
      }
    }

    &.--betfury {
      background-color: rgba(#ed1d49, 0.1);
      position: relative;
      cursor: pointer;

      &::before {
        position: absolute;
        content: "";
        width: 33px;
        height: 20px;
        left: 0;
        top: 0;
        border-left: 3px solid #ed1d49;
        border-top: 3px solid #ed1d49;
      }

      &::after {
        position: absolute;
        content: "";
        width: 33px;
        height: 20px;
        right: 0;
        bottom: 0;
        border-right: 3px solid #ed1d49;
        border-bottom: 3px solid #ed1d49;
      }

      .missions-list__quest-title {
        color: $white;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;
      }

      .missions-list__quest-left {
        img {
          path {
            fill: #ed1d49;
          }
        }
      }

      .currency__icon {
        img {
          path {
            fill: #ed1d49;
          }
        }
      }
    }

    &.--completed {
      .missions-list__quest-title {
        color: $primary60;
      }

      .missions-list__quest-icon path {
        fill: $primary60;
      }
    }

    &:not(:last-child) {
      margin-bottom: 16px;
    }
  }

  .currency {
    @include heading4;
  }

  @media (max-width: $breakpointMobile) {
    &__tabs {
      margin-bottom: 32px;
    }

    &__section {
      &-body {
        padding: 16px;
      }
    }

    &__quest {
      flex-direction: column;
      padding: 20px 16px;

      &-right {
        margin-top: 24px;
        width: 100%;
        flex-direction: row-reverse;
        justify-content: space-between;
        align-items: center;
      }

      &-icon {
        margin-right: 16px;
      }
    }
  }
}

.flip-list-move {
  transition: transform 0.7s;
}
</style>
